import Swiper, {EffectFade, Autoplay, Navigation, Pagination, Thumbs} from "swiper";
import {gsap} from "gsap";
import {isMobile} from './utils';
Swiper.use([EffectFade, Autoplay, Navigation, Pagination, Thumbs]);
import 'swiper/swiper-bundle.min.css';

const productSlider = document.querySelectorAll('.product-image-gallery.swiper');
const miniSlider = document.querySelectorAll('.mini-slider .swiper');
const brandSlider = document.querySelectorAll('.brand-partners .swiper');
const fullSizeSlider = document.querySelectorAll('.full-size-slider-block .swiper');
const valuesSlider = document.querySelectorAll('.values-block .swiper');
const bannerSlider = document.querySelectorAll('.banner-swiper');
const customerSlider = document.querySelectorAll('.customer-slider .swiper');

productSlider.forEach(function (elem, i) {
    const thumbs = new Swiper(".product-image-gallery-thumbs.swiper", {
        modules: [
            Thumbs
        ],
        direction: 'horizontal',
        autoHeight: false,
        spaceBetween: 8,
        slidesPerView: 1,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            },
            960: {
                direction: 'vertical'
            }
        }
    });
    new Swiper(elem, {
        spaceBetween: 10,
        slidesPerView: 1,
        thumbs: {
            swiper: thumbs,
        },
    })
})

if (miniSlider) {
    miniSlider.forEach(function (elem, i) {
        new Swiper(elem, {
            modules: [
                Pagination
            ],
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    })
}

if (brandSlider) {
    brandSlider.forEach(function (elem, i) {
        new Swiper(elem, {
            modules: [
                Navigation
            ],
            slidesPerView: 1.5,
            spaceBetween: 11,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
            },
            navigation: {
                nextEl: '.brand-partners .swiper-button-next',
                prevEl: '.brand-partners .swiper-button-prev',
            },
        });
    })
}

if (fullSizeSlider) {
    fullSizeSlider.forEach(function (elem, i) {
        new Swiper(elem, {
            modules: [
                Navigation
            ],
            slidesPerView: 1, 
            spaceBetween: 0,
            effect: "fade",
            navigation: {
                nextEl: '.full-size-slider-block .swiper-button-next',
                prevEl: '.full-size-slider-block .swiper-button-prev',
            },
        });
    })
}

if (valuesSlider) {
    let valuesSwiper = [];
    
    const initValuesSlider = () => {
        if (window.innerWidth < 970) {
            valuesSlider.forEach(function (elem, i) {
                valuesSwiper[i] = new Swiper(elem, {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                });
            });
        } else {
            valuesSwiper.forEach((swiper) => {
                if (swiper) {
                    swiper.destroy(true, true);
                }
            });
            valuesSwiper = [];
        }
    };

    initValuesSlider();
    window.addEventListener('resize', initValuesSlider);
}

if (bannerSlider) {
    bannerSlider.forEach(function (elem, i) {
        new Swiper(elem, {
            modules: [
                EffectFade,
                Autoplay
            ],
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            fadeEffect: {
                crossFade: true
            },
        });
    })
}

if (customerSlider) {
    customerSlider.forEach(function (elem, i) {
        new Swiper(elem, {
            modules: [
                Navigation
            ],
            slidesPerView: 1.5,
            spaceBetween: 11,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
            },
            navigation: {
                nextEl: '.customer-slider .swiper-button-next',
                prevEl: '.customer-slider .swiper-button-prev',
            },
        });
    })
}